import { ReactElement } from 'react'
import { TextField } from '@ui/forms'

const CreateElementLabelField = (): ReactElement => (
  <TextField
    name="label"
    inputLabel="Name"
    placeholder="leer lassen für automatische Erzeugung"
    data-cy="create-element-label"
  />
)

export default CreateElementLabelField
